import { render } from "./FormCreateOrUpdate.vue?vue&type=template&id=4cba4786&scoped=true"
import script from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"

import "./FormCreateOrUpdate.vue?vue&type=style&index=0&id=4cba4786&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cba4786"

export default script